import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/page-image/qyxq/banner.png';
const _hoisted_1 = {
  class: "qyxq-page"
};
import { isWeChat } from '@/utils/utils';
export default /*@__PURE__*/_defineComponent({
  __name: 'Qyxq',
  setup(__props) {
    const detail = item => {
      const url = 'https://jlisti.com:9600/tech/#/Index';
      // 微信浏览器中 window.open 可能被限制，使用 location.href 替代
      if (isWeChat) {
        window.location.href = url;
      } else {
        window.open(url, '_blank');
      }
    };
    return (_ctx, _cache) => {
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "banner-wrapper"
      }, [_createElementVNode("div", {
        class: "banner-container"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "企业需求",
        class: "banner"
      })])], -1)), _createElementVNode("div", {
        class: "content-bg"
      }, [_createElementVNode("div", {
        class: "content-wrapper"
      }, [_createElementVNode("div", {
        class: "platform-card"
      }, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "platform-title"
      }, "吉林省科技成果服务平台", -1)), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "platform-link"
      }, "https://jlisti.com:9600/tech/#/Index", -1)), _createElementVNode("div", {
        class: "platform-btn"
      }, [_createElementVNode("button", {
        class: "detail-btn",
        onClick: detail
      }, "查看详情")])])])]), _createVNode(_component_Footer)]);
    };
  }
});